import React, {FC} from 'react';
import {List} from 'antd';
import {DropdownMenu, DropdownMenuItem} from './DropdownMenu';

interface HeaderAdviceListItemProps {
    title: string;
    icon: React.ReactNode;
    items: DropdownMenuItem[];
}

export const HeaderAdviceListItem: FC<HeaderAdviceListItemProps> = ({title, icon, items}) => {
    return items.length > 0 ? (
        <List.Item className="item">
            <DropdownMenu title={title} icon={icon} items={items} />
        </List.Item>
    ) : null;
};
